import { useEffect, useState } from "react";
import ContentLayout from "../../layout/contentLayout";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { Grid } from "@mui/material";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import StackKit from "@/shared/components/kit/stack";
import Content from "./content";
import { fetchListCashTransactionList } from "@/api/merchant/request.get";
import { useQuery } from "@tanstack/react-query";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
/**
 * WalletBalanceReports
 *
 * نمایش گزارش موجودی نقدی کیف پول.
 *
 * این کامپوننت تراکنش‌های نقدی کیف پول پذیرنده را با استفاده از React Query دریافت و نمایش می‌دهد.
 * کاربر می‌تواند تراکنش‌ها را بر اساس نوع فیلتر کرده و داده‌ها به صورت صفحه‌بندی شده مشاهده کند.
 *
 * ویژگی‌ها:
 * - دریافت داده‌ها از API `fetchListCashTransactionList`
 * - فیلتر تراکنش‌ها بر اساس نوع تراکنش (افزایش موجودی، خرید POS، خرید اپلیکیشن، خرید درگاه IPG)
 * - مدیریت صفحه‌بندی تراکنش‌ها
 * - نمایش داده‌ها در جدول از طریق کامپوننت `Content`
 *
 * @returns JSX.Element
 */

const WalletBalanceReports = () => {
  // const [value, setValue] = useState("همه تراکنش ها");
  const [selectedNumber, setSelectedNumber] = useState("charge_merchant_wallet");
  const [page, setPage] = useState(1);

  const {data: dataListCashTransaction,isFetched,refetch,isLoading,} = useQuery({
    queryKey: [
      "ListPazirandeClubsWalletBalanceReports-data",
      selectedNumber,
      page,
    ],

    queryFn: () =>
      fetchListCashTransactionList(
        selectedNumber === "all" ? "charge_merchant_wallet" : selectedNumber,
        page
      ),
  });

  useEffect(() => {
    refetch();
  }, []);

  const dataOptionSelect = [
    { value: "charge_merchant_wallet", label: "افزایش موجودی توسط پذیرنده" },
    { value: "cash_buy_pose_device", label: "تراکنش های خرید از دستگاه pos" },
    { value: "cash_buy_application", label: "تراکنش های خرید از اپلیکیشن" },
    { value: "cash_buy_ipg", label: "تراکنش های خرید درگاه ipg" },
  ];

  return (
    <ContentLayout icon={<AccountBalanceWalletOutlinedIcon />} title="موجودی نقدی کیف پول"
      detailTitle={
        <Grid size={12} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 2}}>
          <StackKit sx={{ width: "100%" }} direction={{sm:'row',xs:'column'}} justifyContent={{sm:'end',xs:'center'}} flexGrow={"wrap"} alignItems={"center"} gap={1}>
            <TypoGraphyKit variant="body1">
              دسته بندی گزارش ها کیف پول نقدی
            </TypoGraphyKit>
            <CustomSelectNormal label="" value={selectedNumber} onChange={(e, item) => {setSelectedNumber(e.target.value);}} options={dataOptionSelect ?? []} getOptionLabel={(item) => `${item.label}`} getOptionValue={(item) => item.value} width={"fit-content"}/>
          </StackKit>
        </Grid>
      }
      isContainerFluid
    >
      <Content dataTable={dataListCashTransaction} selectedNumber={selectedNumber} setPage={setPage} page={page}/>
    </ContentLayout>
  );
};

export default WalletBalanceReports;
